import api from "../api";

/**
 * Arma los query params del listado. Acepta el id de cuenta suelto (llamadas
 * viejas) o un objeto con accountId, isRead, severity, typeCodes, limit y offset.
 */
function buildListParams(options) {
  if (options == null) return {};
  if (typeof options === "number" || typeof options === "string") {
    return { account_id: options };
  }

  const { accountId, isRead, severity, typeCodes, limit, offset } = options;
  const params = {};

  if (accountId != null) params.account_id = accountId;
  if (typeof isRead === "boolean") params.is_read = isRead;
  if (severity) params.severity = severity;
  if (Array.isArray(typeCodes) && typeCodes.length) {
    params.notification_type_code = typeCodes.join(",");
  }
  if (limit != null) params.limit = limit;
  if (offset) params.offset = offset;

  return params;
}

export const notificationsService = {
  async list(options = null) {
    const response = await api.get("/api/v1/notifications/", {
      params: buildListParams(options),
    });
    return response.data;
  },

  async unreadCount(accountId = null) {
    const response = await api.get("/api/v1/notifications/unread-count/", {
      params: accountId ? { account_id: accountId } : {},
    });
    return response.data;
  },

  async markRead(notificationId) {
    const response = await api.patch(
      `/api/v1/notifications/${notificationId}/read/`,
      {},
    );
    return response.data;
  },

  async markAllRead(accountId = null) {
    const response = await api.patch(
      "/api/v1/notifications/read-all/",
      null,
      {
        params: accountId ? { account_id: accountId } : {},
      },
    );
    return response.data;
  },
};
